export const productCardTemplate = `
  <div class="product_block">
    <div class="product-container text-left product-block">
      <div class="product-image-container image">
        <a class="product_img_link" href="" title="">
          <img class="replace-2x img-responsive" src="" loading="lazy" alt="" />
          <span class="product-additional" data-idproduct="4458022076476">
            <img
              class="replace-2x img-responsive"
              alt=""
              src=""
              loading="lazy"
            />
          </span>
        </a>
      </div>
      <div class="product-meta">
        <h3 class="name">
          <a
            class="product-name"
            href="https://canarias.mediamarkt.es/products/apple-watch-s8-2022-gps-41-mm-caja-de-aluminio-vidrio-delantero-ion-x-correa-deportiva-medianoche"
            title=""
          ></a>
        </h3>
        <div class="review">
          <span
            class="spr-badge"
            id="spr_badge_4458022076476"
            data-rating="4.428571428571429"
            ><span class="spr-starrating spr-badge-starrating"
              ><i class="spr-icon spr-icon-star" aria-hidden="true"></i
              ><i class="spr-icon spr-icon-star" aria-hidden="true"></i
              ><i class="spr-icon spr-icon-star" aria-hidden="true"></i
              ><i class="spr-icon spr-icon-star" aria-hidden="true"></i
              ><i
                class="spr-icon spr-icon-star-half-alt"
                aria-hidden="true"
              ></i></span
            ><span class="spr-badge-caption"></span>
          </span>
        </div>
        <div class="content_price">
          <span class="compare-at-price">
          </span>
          <span class="regular-price">
          </span>
        </div>
        <div class="functional-buttons"></div>
      </div>
    </div>
  </div>
`;
